import { render, staticRenderFns } from "./KundeProfile.vue?vue&type=template&id=e3e9d386&scoped=true&"
import script from "./KundeProfile.vue?vue&type=script&lang=js&"
export * from "./KundeProfile.vue?vue&type=script&lang=js&"
import style1 from "./KundeProfile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e9d386",
  null
  
)

export default component.exports